/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	UserList: function(state) {
		return state.UserList;
	},
	Total: function(state) {
		return state.Total;
	},
	userListLoaded: function(state) {
		return state.userListLoaded;
	},
	Role: function(state) {
		return state.Role;
	},
	TaxCode: function(state) {
		return state.TaxCode;
	},
	User: function(state) {
		return state.user;
	},
	WorkPermission: function(state) {
		return state.WorkPermission;
	},
	JobTitles: function(state) {
		return state.JobTitles;
	},
	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	},
	MWSToken(state) {
		return state.MWSTokenV2;
	},
	UserConfig(state) {
		return state.userConfig;
	},
	FeatureTooltipConfig: function(state) {
		return state.featureTooltipConfig;
	}
};
